export default __webpack_public_path__ + "static/christian-helvin-4caf80c2fbf13fc9dbe26fa10a7eb7f6.png";